import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/components/layout/layout.component';
import { LoginComponent, ForbiddenComponent, AuthGuard, AccessGuard } from './auth';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'calculation',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'calculation',
        loadChildren: () => import('./calculation/calculation.module').then((m) => m.CalculationModule),
        canActivate: [AccessGuard],
      },
      {
        path: 'saved-calculations',
        loadChildren: () => import('./saved-calculations/saved-calculations.module').then((m) => m.SavedCalculationsModule),
        canActivate: [AccessGuard],
      },
      {
        path: '**',
        redirectTo: 'calculation',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
